import React from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';


import AdminRolesModal from '../AdminRolesModal';
import Link from '../../Link';
import Loader from '../../../components/Common/Loader';
import CustomPagination from '../../CustomPagination/CustomPagination';

import messages from '../../../locale/messages';
import { openAdminRolesModal } from '../../../actions/siteadmin/modalActions';
import { deleteAdminRole } from '../../../actions/siteadmin/AdminRoles/manageAdminRoles';
import getCurrentPage from '../../../helpers/getCurrentPage';

import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../components/commonStyle.css';
import s from './AdminRolesManagement.css';
class AdminRolesManagement extends React.Component {
  static defaultProps = {
    data: []
  };

  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
    }
  }

  paginationData = (currentPage) => {
    const { refetch } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  handleDelete = async (id, currentPage) => {
    const { deleteAdminRole, data, refetch } = this.props;
    currentPage = await getCurrentPage({ results: data?.results, page: currentPage });
    let variables = { currentPage };
    const deleteValue = await deleteAdminRole(id, currentPage);
    if (deleteValue?.status === 200) {
      this.setState({ currentPage });
      await refetch(variables);
    }
  }

  render() {
    const { data, openAdminRolesModal, loading } = this.props;
    const { currentPage } = this.state;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manageAdminRoles)}</h1>
        <AdminRolesModal paginationData={this.paginationData} currentPage={currentPage} />
        <div className={s.exportDisplay}>
          <div />
          <div className={cx(s.exportTextSection)}>
            <Button
              className={cx(bt.btnPrimary)}
              onClick={() => openAdminRolesModal('add')}
            >
              <FormattedMessage {...messages.addNewLabel} />
            </Button>
          </div>
        </div>
        {
          loading && <div>
            <Loader type="circle" />
          </div>
        }
        {!loading &&
          <div className='tableOuterContainer'>
            <Table
              className="tableContainer"
            >
              <thead>
                <tr>
                  <th scope="col"><FormattedMessage {...messages.id} /></th>
                  <th scope="col"><FormattedMessage {...messages.adminName} /></th>
                  <th scope="col"><FormattedMessage {...messages.description} /></th>
                  <th scope="col"><FormattedMessage {...messages.edit} /></th>
                  <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                </tr>
              </thead>
              <tbody>
                {
                  data?.results && data?.results?.length > 0 && data?.results?.map((value, key) => {
                    return (
                      <tr key={key}>
                        <td data-label={formatMessage(messages.id)}>{value?.id} </td>
                        <td data-label={formatMessage(messages.adminName)}>{value?.name}</td>
                        <td data-label={formatMessage(messages.description)}>{value?.description}</td>
                        <td data-label={formatMessage(messages.edit)}>
                          <div>
                            <Link noLink onClick={() => openAdminRolesModal('edit', value)} className={s.noLink}>
                              <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                              <span className={s.vtrMiddle}>
                                <FormattedMessage {...messages.editAction} />
                              </span>
                            </Link>
                          </div>
                        </td>
                        <td data-label={formatMessage(messages.deleteAction)}>
                          <div>
                            <Link noLink onClick={() => this.handleDelete(value?.id, currentPage)} className={s.iconBtn}>
                              <CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
                              <span className={s.vtrMiddle}><FormattedMessage {...messages.deleteAction} /></span>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    )
                  })
                }
                {
                  data?.results && data?.results?.length === 0 && <tr>
                    <td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
                  </tr>
                }
              </tbody>
            </Table>
          </div>
        }
        {
          data?.results?.length > 0 &&
          <div className={cx(bt.space5, bt.spaceTop5)}>
            <CustomPagination
              total={data?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.roles)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  openAdminRolesModal,
  deleteAdminRole
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(AdminRolesManagement)));